<template>
  <div class="scrollable">
    <div class="page-header">
      <div
        class="page-header header-accent-gradient card-base card-shadow--small"
        style="
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          margin-bottom: 0 !important;
        "
      >
        <h1>{{ lastRouter }}</h1>

        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">
            <i class="mdi mdi-home-outline"></i>
          </el-breadcrumb-item>
          <el-breadcrumb-item
            v-for="(c, index) in crumbs"
            :key="index"
            :to="{ path: c.to }"
            >{{ c.text_i18n === null ? c.text : c.text_i18n }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <el-menu
        :default-active.sync="activeIndex"
        mode="horizontal"
        @select="handleSelect"
        class="card-shadow--small"
      >
        <template v-for="(rule, index) in routes">
          <template
            v-if="rule.children && rule.children.length > 0 && rule.meta.review"
          >
            <template v-for="(child, index) in rule.children">
              <el-menu-item
                v-if="child.meta.index"
                :key="child.name + index"
                :index="child.name"
                :disabled="rule.meta.disable ? rule.meta.disable : false"
                ><i :class="rule.meta.icon"></i>
                {{ $t(`${mainRoute}.${child.name}`) }}
              </el-menu-item>
            </template>
          </template>
          <template v-else>
            <el-submenu
              v-if="rule.children && rule.children.length > 0"
              :key="rule.name + index"
              :index="rule.name"
              :disabled="rule.meta.disable ? rule.meta.disable : false"
              ><template slot="title"
                ><i :class="rule.icon"></i
                >{{ $t(`${mainRoute}.${rule.name}.main`) }}</template
              >
              <template v-for="(child, index) in rule.children">
                <!-- nivel2 -->
                <el-submenu
                  v-if="child.children && child.children.length > 0"
                  :key="child.name + index"
                  :index="child.name"
                  :disabled="child.meta.disable ? child.meta.disable : false"
                  ><template slot="title"
                    ><i :class="child.icon"></i
                    >{{
                      $t(`${mainRoute}.${rule.name}.${child.name}.main`)
                    }}</template
                  >
                  <template v-for="(child2, index) in child.children">
                    <el-menu-item
                      v-if="child2.meta.index"
                      :key="child2.name + index"
                      :index="child2.name"
                      :disabled="
                        child2.meta.disable ? child2.meta.disable : false
                      "
                      >{{
                        $t(
                          `${mainRoute}.${rule.name}.${child.name}.${child2.name}`
                        )
                      }}
                    </el-menu-item>
                  </template>
                </el-submenu>
                <template v-else>
                  <el-menu-item
                    v-if="child.meta.index"
                    :key="child.name + index"
                    :index="child.name"
                    :disabled="child.meta.disable ? child.meta.disable : false"
                    ><i :class="child.meta.icon"></i>
                    {{ $t(`${mainRoute}.${rule.name}.${child.name}`) }}
                  </el-menu-item>
                </template>
              </template>
              <!-- end nivel 2 -->
            </el-submenu>
            <template v-else>
              <el-menu-item
                v-if="
                  rule.meta.index ||
                  currentUser.Roles.map((role) => role.Id).includes(
                    rule.meta.role
                  )
                "
                :key="rule.name + index"
                :index="rule.name"
                :disabled="rule.meta.disable ? rule.meta.disable : false"
                ><i :class="rule.meta.icon"></i>
                {{ $t(`${mainRoute}.${rule.name}`) }}
              </el-menu-item>
            </template>
          </template>
        </template>
      </el-menu>
    </div>

    <transition name="slide-fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "RabbeyTopMenu",
  data() {
    return {
      routes: [],
      mainRoute: "",
      mainRoutePath: "",
      activeIndex: ""
    };
  },

  methods: {
    // eslint-disable-next-line no-unused-vars
    handleSelect(key, keyPath) {
      if (key === this.$router.currentRoute.name) {
        window.location.reload();
        return false;
      }
      this.$router.push({ name: key });
      this.$emit("push-page", { page: key });
    },
    setLink(path) {
      this.activeIndex = path;
    }
  },
  created() {
    this.setLink(this.$router.currentRoute.name);

    const current = this.$router.currentRoute;
    this.$router.options.routes.forEach((route) => {
      if (route.path === current.matched[0].path) {
        this.routes = route.children;
        this.mainRoute = route.name;
        this.mainRoutePath = route.path;
      }
    });

    // eslint-disable-next-line no-unused-vars
    this.$router.afterEach((to, from) => {
      this.setLink(this.$router.currentRoute.name);
    });
  },
  computed: {
    /**
     * El objectivo de computed es calcular las migajas de pan.
     * En estara en deshuso hasta que termine bien como se manejara este tema.
     */
    crumbs() {
      let pathArray = this.$route.path.split("/");
      pathArray.shift();
      let breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {
        if (this.$route.matched[idx].meta === undefined) {
          return breadcrumbArray;
        }

        const meta = this.$route.matched[idx].meta;

        breadcrumbArray.push({
          path: path,
          to: breadcrumbArray[idx - 1]
            ? "/" + breadcrumbArray[idx - 1].path + "/" + path
            : "/" + path,
          text: meta.title || path,
          text_i18n:
            meta.title_i18n !== undefined ? this.$t(meta.title_i18n) : null
        });
        return breadcrumbArray;
      }, []);
      return breadcrumbs;
    },
    lastRouter() {
      const lastRoute = this.crumbs[this.crumbs.length - 1];

      return lastRoute.text_i18n === null
        ? lastRoute.text
        : this.$t(lastRoute.text_i18n);
    }
  }
};
</script>

<style scoped>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
